import { NavLink } from "react-router-dom";
import { useState } from "react";
import './Header.css';
import { MdMenu, MdClose} from "react-icons/md";
import logo from '../../logo.svg'

export default function Header() {
  const Link = ({ isActive }) => `navLink ${isActive ? "active" : ""}`;
  const mobileLink = ({ isActive }) => `mobileNavLink ${isActive ? "active" : ""}`;

  const [open, setOpen] = useState(false);

  
  const navigation = [
    { to: "/", label: "Index", end: true },
    { to: "/contact", label: "Contact" },
  ];

  return (

    <>
      <header className="header">
        <div className="headerContainer">
          <div className="logoContainer">
            <span className="logoName">Lurscript</span>
            <img src={logo} alt="Lurscript Logo" className="logoImage" />
          </div>

          <nav className="navbar">
            {navigation.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={Link}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

        </div>

      </header>

      


      <header className="mobileHeader">

        <div className="mobileHeaderContainer">

          <div className="mobileLogoContainer">
            <span className="logoName">Lurscript</span>
            <img src={logo} alt="Lurscript Logo" className="logoImage" />
          </div>


          <button
            type="button"
            onClick={() => setOpen((currentOpen) => !currentOpen)}
            className="mobileMenuButton"
            aria-label={open ? "Close navigation menu" : "Open navigation menu"}
            aria-expanded={open}
            aria-controls="mobile-navigation"
          >
            {open ? <MdClose aria-hidden="true" className="mobileCloseIcon" /> : <MdMenu aria-hidden="true" className="mobileMenuIcon" />}
          </button>


          {open &&

            <div className="mobileSidebar" id="mobile-navigation">

              <nav className="mobileNavbar">
                {navigation.map((item) => (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    end={item.end}
                    className={mobileLink}
                    onClick={() => setOpen(false)}
                  >
                    {item.label}
                  </NavLink>
                ))}
              </nav>


            </div>


          }
        </div>

      </header>

    </>
  );
}
